import {
  getProductsByBrand,
  getProductsByCategory,
  getProductsBySearch,
} from 'aster-foundation/core/epharmacy/Product/redux/action';
import logger from '@common/Utility/logger';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useState, useRef, useEffect } from 'react';
import Image from 'next/image';
import { Col, Container, Row } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import dynamic from 'next/dynamic';
import {
  AE_GLOBAL,
  DEFAULT_SORT_BY,
  EXPRESS_DEFAULT_FLAG,
  FACET_KEYS,
  ONE_ASTER_CATEGORY,
  ONLINE_PHARMACY_ROUTE,
  ONLINE_PHARMACY_TITLE,
  BRANDS_PHARMACY_TITLE,
  BRAND_LISTING_ROUTE,
  PLP_API_PARAMS_SEPARATOR,
  PLP_PAGE_SIZE,
  SCHEDULED_EXPRESS_FLAG,
  ONLINE_PHARMACY_CATEGORY_ROUTE,
  ONLINE_PHARMACY_BRAND_ROUTE,
  HOME,
  FLAGSMITH_KEYS,
} from '@common/Utility/constants';
import { EventEmitter } from '@common/Utility/eventEmitter';
import {
  dataLayerSendEpharmacyPageViewEvent,
  dataLayerSendEvent,
  dataLayerSendPageViewEvent,
  getProductItemObject,
} from 'Epharmacy/EpharmacyAnalytics';
import BlankCard from '@common/Component/BlankCard/BlankCard';
import BreadcrumbControl from '@common/Component/Forms/BreadCrumb/Breadcrumb';
import Loader from '@common/Component/Loader/Loader';
import ProductItem from '@common/Component/ProductItem/ProductItem';
import { sendPageViewEvent } from '@common/Utility/analytics-utils';
import useScrollHandler from '@common/Context/useScrollHandler';
import SearchTitleBar from './SearchTitleBar';
import PlpBottomCart from './PlpBottomCart';
import { getProductListingAttributes } from '@common/Utility/insider-object-integration';
import useWindowDimensions from '@common/Context/useWindowDimensions';
import SlickSlider from '@common/Component/SlickSlider/SlickSlider';
import SearchSortBy from './SearchSortBy';
import { getBrandsByCategory, getAllBrands } from 'aster-foundation/core/epharmacy/Category/redux/action';
import BannerSliderWithImage from '@common/Component/BannerSliderWithImage/BannerSliderWithImage';
import GlobalUpsellingCarousel from '@common/Component/GlobalUpsellingCarousel/GlobalUpsellingCarousel';
import { errorHandlingEpharmacy, getAttributeItemFromArray, getReferralPageForGA } from '@common/Utility/common-utils';
import { IC_SCHEDULE_MOON_ICON } from '../../../public/images';
import { flagsmith } from '@common/Lib/Flagsmith';
import { debounce } from 'lodash';
import { useNavigationURL } from '@common/Utility/generateNavigationURL';
import { MY_ASTER_CATEGORY, PAGE_NAME, SCREEN_NAME } from '@common/Constants/analytics';
import { useTranslation } from '@common/i18n';
import DownloadAppBanner from './DownloadAppBanner';

const ProductFilter = dynamic(() => import('../../Common/Component/ProductFilter/ProductFilter'));
const NoResultFound = dynamic(() => import('./NoResultFound'));
const Pagination = dynamic(() => import('../../Common/Component/Pagination/Pagination'));
const NoResultFoundReCarousel = dynamic(() => import('../NoResultFoundReCarousel/NoResultFoundReCarousel'));
const UpSellingCarousel = dynamic(() => import('../RecommendationEngine/UpSellingCarousel/UpSellingCarousel'));
const sortFilter = [
  {
    key: 'name-asc',
    displayName: 'Name (A-Z)',
  },
  {
    key: 'relevance',
    displayName: 'Relevance',
  },
  {
    key: 'new_bool-desc',
    displayName: 'Newest',
  },
  {
    key: 'price-asc',
    displayName: 'Prices (Low First)',
  },
  {
    key: 'price-desc',
    displayName: 'Prices (High First)',
  },
];

export const responsive = [
  {
    breakpoint: 980,
    settings: {
      slidesToShow: 5,
    },
  },
  {
    breakpoint: 768,
    settings: {
      slidesToShow: 3,
    },
  },
  {
    breakpoint: 480,
    settings: {
      slidesToShow: 1,
      variableWidth: true,
      infinite: true,
    },
  },
];

const SearchResultPageInner = (props) => {
  const router = useRouter();
  const dispatch = useDispatch();
  const scrollY = useScrollHandler();
  const size = useWindowDimensions();
  const generateURL = useNavigationURL();
  const t = useTranslation();
  const lastScrollY = useRef(0);
  const appConfigData = useSelector((state) => state?.astercore?.AppConfig?.data?.data);
  const userLocation = useSelector((state) => state?.app?.userLocationReducer);
  const defaultSortBy = {...DEFAULT_SORT_BY, displayName: t('EpharmacyFilter.relevance')}

  const [gaPageType, setGAPageType] = useState(props?.pageType);
  const [searchedFor, setSearchFor] = useState([]);
  const [sortFilterOptions, setSortFilterOptions] = useState(sortFilter ?? []);
  const [sortBy, setSortBy] = useState(defaultSortBy);
  const [currentPage, setCurrentPage] = useState(1);
  const [plpBanner,setPlpBanner] = useState([]);
  const pageType = getReferralPageForGA(router?.asPath);
  const screenName = router?.pathname;
  const [searchData, setSearchData] = useState({
    pageSize: PLP_PAGE_SIZE,
    totalEntry: props?.facetResponse?.totalItems || 0,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [isExpress, setIsExpress] = useState(EXPRESS_DEFAULT_FLAG);
  const [isFlash, setIsFlash] = useState(false);
  const [isFilterApplied, setIsFilterApplied] = useState(false);
  const [facetResponse, setFacetResponse] = useState(props?.facetResponse);
  const [selectedFacets, setSelectedFacets] = useState(props?.selectedFacet ? [props?.selectedFacet] : []);
  const [recentSelectedFacet, setRecentSelectedFacet] = useState();
  const [listData, setListData] = useState(facetResponse?.data ?? []);
  const [facetList, setFacetList] = useState(facetResponse?.facetList ?? []);
  const [pageName, setPageName] = useState('');
  const [priceFacet, setPriceFacet] = useState(props?.priceFacet);
  const [selectedPrices, setSelectedPrices] = useState(() => ({
    minVal: props?.priceFacet?.min,
    maxVal: props?.priceFacet?.max,
  }));
  const [loadingList, setLoadingList] = React.useState(false);
  const [firstSetData, setFirstSetData] = useState(facetResponse?.data ?? []);
  const [secondSetData, setSecondSetData] = useState([]);
  const [addToCartSkuIds, setAddToCartSkuIds] = useState('');
  const [showUpSellingCarousel, setShowUpSellingCarousel] = useState(false);
  const [isIncreasing, setIsIncreasing] = useState(true);
  const analayticsParams = useRef();
  const isScheduledProducts = facetResponse?.data?.filter((ele) => ele?.isScheduled);
  const ae_web_scheduled_express = flagsmith.getValue(SCHEDULED_EXPRESS_FLAG, { json: true });
  const web_feature_flaging = flagsmith.getValue(FLAGSMITH_KEYS.WEB_FEATURE_FLAGING, {json: true});
  const showSheduledDeliveryMessage = ae_web_scheduled_express?.showSheduledDeliveryMessage;

  const q = React.useMemo(() => router?.query?.q || props?.queryParam?.q || undefined, [router?.query?.q]);
  const category = React.useMemo(
    () => router?.query?.category || props?.queryParam?.category || undefined,
    [router?.query?.category],
  );
  const brand = React.useMemo(
    () => router?.query?.brand || props?.queryParam?.brand || undefined,
    [router?.query?.brand],
  );
  const offerType = React.useMemo(
    () => router?.query?.offerType || props?.queryParam?.offerType || undefined,
    [router?.query?.offerType],
  );
  const title = React.useMemo(
    () => router?.query?.title || props?.queryParam?.title || undefined,
    [router?.query?.title],
  );
  const name = React.useMemo(() => router?.query?.name || props?.queryParam?.name || undefined, [router?.query?.name]);
  const currency = appConfigData?.find((c) => c.name === 'currency')?.value;

  // memorize dependency data for prevent multiple api call for same data
  const pageDependent = React.useMemo(() => router?.query?.page, [router?.query?.page]);
  const SortByDependent = React.useMemo(() => sortBy, [sortBy]);
  const selectedFacetsDependent = React.useMemo(() => selectedFacets, [selectedFacets]);
  const selectedPriceDependent = React.useMemo(() => selectedPrices, [selectedPrices]);
  const isExpressDependent = React.useMemo(() => isExpress, [isExpress]);
  const isFlashDependent = React.useMemo(() => isFlash, [isFlash]);

  const userLocationZone = React.useMemo(() => userLocation?.zone, [userLocation?.zone]);
  const resetAllFilters = () => {
    setIsExpress(false);
    setIsFlash(false);
    setSelectedPrices({ minVal: props?.priceFacet?.min, maxVal: props?.priceFacet?.max });
    setSelectedFacets([]);
    setSortBy(defaultSortBy);
    setCurrentPage(1);
    EventEmitter.dispatch('resetFilters');
  };

  useEffect(() => {
    if (props?.queryParamCategory) {
      const params = {
        categoryId: props?.queryParamCategory,
      };
      dispatch(
        getBrandsByCategory({
          params,
          onSuccess: (response) => {
            setPlpBanner(response?.data);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
            logger.error(err);
          },
        }),
      );
    }
  }, [props?.queryParamCategory]);

  useEffect(() => {
    if (router?.query?.brand || props?.queryParamBrands) {
      const params = {
        pageSize: 1,
        pageFrom:0,
        key:'name',
        value:router?.query?.brands[0],
      };
  
      dispatch(
        getAllBrands({
          params: params,
          onSuccess: (response) => {
            setPlpBanner(response?.data);
          },
          onFailure: (err) => {
            errorHandlingEpharmacy(err, true, screenName, pageType);
          },
        }),
      );
    }
  }, [router?.query?.brand, props?.queryParamBrands]);

  const pageBanners = plpBanner?.[0]?.bannerData?.map((bannerItem, index) => {
    return {
      imageWeb: bannerItem?.webImage,
      linkWeb: bannerItem?.ctaWebLink,
      imageMobile: bannerItem?.appImage,
      position: bannerItem?.priority,
      bannerName:bannerItem?.bannerName,
    };
  });

  const onSuccessPLP = async (response) => {
    setFacetResponse(response);
    setLoadingList(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const onFailurePLP = (err) => {
    setLoadingList(false);
    errorHandlingEpharmacy(err, true, screenName, pageType);
  };

  const onFilterChanged = () => {
    const filterParams = {};
    const pageNumber = router?.query?.page;
    let params = {
      zone: userLocation?.zone?.join(','),
      page: pageNumber ? pageNumber - 1 : 0,
      pageSize: PLP_PAGE_SIZE,
      sort: sortBy?.key,
    };
    if (isExpress) {
      filterParams.express_bool = isExpress;
    }
    if (isFlash) {
      filterParams.isFlash = isFlash;
    }
    if (
      typeof selectedPrices?.minVal !== 'undefined' &&
      typeof selectedPrices?.maxVal !== 'undefined' &&
      selectedPrices?.maxVal > selectedPrices?.minVal &&
      (selectedPrices?.minVal !== props?.priceFacet.min || selectedPrices?.maxVal !== props?.priceFacet.max)
    ) {
      params = {
        ...params,
        minPrice: props?.priceFacet?.min,
        maxPrice: props?.priceFacet?.max,
      };
      filterParams.price = `${selectedPrices?.minVal}${PLP_API_PARAMS_SEPARATOR}${selectedPrices?.maxVal}`;
    }

    if (selectedFacets?.length > 0) {
      selectedFacets.forEach((facet) => {
        if (facet?.values?.length > 0) {
          if (facet?.key === 'categoryPath') {
            const allPath = facet?.values?.map((v) => v.key);
            if (allPath?.length > 0) {
              filterParams[facet?.key] = allPath
                ?.filter((fItem) => fItem && fItem !== '')
                ?.join(PLP_API_PARAMS_SEPARATOR);
            }
          } else {
            const allValues = facet?.values?.map((v) => v.key);
            filterParams[facet?.key] = allValues
              ?.filter((fItem) => fItem && fItem !== '')
              ?.join(PLP_API_PARAMS_SEPARATOR);
          }
        }
      });
    }

    if ((router?.query?.brand || props?.queryParamBrands) && userLocation?.zone?.[0]) {
      setIsFilterApplied(true);
      setLoadingList(true);
      // call brand api
      let brandId = props?.queryParamBrands;
      if (router?.query?.brand) {
        brandId = router?.query?.brand;
      }
      params = props?.getParams(router, params, filterParams);
      dispatch(
        getProductsByBrand({
          params: { id: brandId, query: params },
          onSuccess: onSuccessPLP,
          onFailure: onFailurePLP,
        }),
      );
    } else if ((router?.query?.category || props?.queryParamCategory) && userLocation?.zone?.[0]) {
      setIsFilterApplied(true);
      setLoadingList(true);
      let catId = props?.queryParamCategory;
      if (router?.query?.category) {
        catId = router?.query?.category;
      }
      dispatch(
        getProductsByCategory({
          params: { id: catId, query: props?.getParams(router, params, filterParams) },
          onSuccess: onSuccessPLP,
          onFailure: onFailurePLP,
        }),
      );
    } else if (userLocation?.zone?.length > 0) {
      setIsFilterApplied(true);
      setLoadingList(true);
      dispatch(
        getProductsBySearch({
          params: props?.getParams(router, params, filterParams),
          onSuccess: onSuccessPLP,
          onFailure: onFailurePLP,
        }),
      );
    }

    if (sortBy.key !== DEFAULT_SORT_BY.key) filterParams['sort'] = sortBy.key;

    let filterQuery = '';
    if(router?.asPath?.includes('?text')) {
      filterQuery = `${router?.asPath}&q=`
    } else {
      filterQuery = '?q='
    }
    Object.keys(filterParams).forEach((item, index) => {
      filterQuery += `${index > 0 ? ':' : ''}${item}:${filterParams[item]}`;
    });

    if (Object.keys(filterParams)?.length > 0) {
      const title = 'filteredRoute';
      history.pushState(null, title, filterQuery);
    } else {
      history.pushState(null, null, router?.asPath?.split('?q=')[0]);
    }
  };

  const handleIsExpress = (checked) => {
    setIsFilterApplied(true);
    setShowUpSellingCarousel(false);
    if (isFilterApplied && router?.query?.page > 1) {
      router.push({ query: { ...router.query, page: 1 } }, undefined, { shallow: true });
    }
    if (checked) {
      setIsExpress(true);
      setRecentSelectedFacet({
        displayName: AE_GLOBAL.EXPRESS,
        values:[{displayName: AE_GLOBAL.EXPRESS}],
        selectedFacet: { displayName: AE_GLOBAL.EXPRESS, selected: true },
      });
    } else {
      setIsExpress(false);
      setRecentSelectedFacet({
        displayName: AE_GLOBAL.EXPRESS,
        values: [],
        selectedFacet: { displayName: AE_GLOBAL.EXPRESS, selected: false },
      }); 
    }
  };

  const handleIsFlash = (checked) => {
    setIsFilterApplied(true);
    setShowUpSellingCarousel(false);
    if (isFilterApplied && router?.query?.page > 1) {
      router.push({ query: { ...router.query, page: 1 } }, undefined, { shallow: true });
    }
    if (checked) {
      setIsFlash(true);
      setRecentSelectedFacet({
        displayName:AE_GLOBAL.FLASH,
        values:[{displayName: AE_GLOBAL.FLASH}],
        selectedFacet: { displayName: AE_GLOBAL.FLASH, selected: true },
      });
    } else {
      setIsFlash(false);
      setRecentSelectedFacet({
        displayName: AE_GLOBAL.FLASH,
        values: [],
        selectedFacet: { displayName: AE_GLOBAL.FLASH, selected: false },
      }); 
    }
  };

  const isPriceFilterSelected = () =>
    typeof selectedPrices?.minVal !== 'undefined' &&
    typeof selectedPrices?.maxVal !== 'undefined' &&
    (props?.priceFacet?.min !== selectedPrices?.minVal || props?.priceFacet?.max !== selectedPrices?.maxVal);

  const getBreadcrumbCurrentText = () => {
    if (props?.facetResponse?.filterText && props?.facetResponse?.filterText !== '') {
      return props?.facetResponse?.filterText;
    }
    if (props?.facetResponse?.searchText && props?.facetResponse?.searchText !== '') {
      return props?.facetResponse?.searchText;
    }
    if (router?.query?.q && router?.query?.q !== '') {
      return router?.query?.q;
    }
    if (name && name !== '') {
      return name;
    }
    if (title && title !== '') {
      return title;
    }
    return '';
  };

  const checkFilterApplied = listData?.length > 0 || category || name || brand;

  let screenNameForEvent = '';
  if (title) {
    screenNameForEvent = title;
  } else if (name) {
    screenNameForEvent = name;
  } else if (searchedFor?.length > 0) {
    screenNameForEvent = searchedFor?.[0];
  } else screenNameForEvent = 'Search Results';

  const getNumber = () => {
    const deviceSize = size.width;
    if (deviceSize >= 1024) {
      return 4;
    } else if (deviceSize < 1024 && deviceSize > 768) {
      return 3;
    } else if (deviceSize <= 768 && deviceSize > 480) {
      return 2;
    } else {
      return 2;
    }
  };

  const getIndex = (number) => {
    const index = getNumber();
    if (number % index === 0) {
      return number;
    }
    const modulo = number % index;
    return number + (index - modulo);
  };

  const getProductIndexAddedToCart = (index, sku) => {
    setAddToCartSkuIds(sku);
    const updatedIndex = getIndex(index + 1);
    const listDataLength = listData.length;
    const firstSliceData = listData.slice(0, updatedIndex);
    const secondSliceData = listData.slice(firstSliceData.length, listDataLength);
    setFirstSetData(firstSliceData);
    setSecondSetData(secondSliceData);
    setShowUpSellingCarousel(true);
  };

  React.useEffect(() => {
    setListData(facetResponse?.data);
    if (facetResponse?.data?.length > 0) {
      setFacetList(facetResponse?.facetList);
      let ListName = 'Search Result Page';
      if (router?.query?.q) {
        ListName = 'Search Result Page';
      } else if (props?.queryParamBrands || props?.queryParamCategory) {
        ListName = name ?? 'Product Listing Page';
      }
      const listingData = {
        item_list_id: category || brand || props?.queryParamBrands || props?.queryParamCategory || '',
        item_list_name: ListName,
        section_name: name ?? 'Product Listing page',
        product_type: 'Epharmacy',
        list_type: 'Category List',
        referrer_page: props?.referrerPage,
        ecommerce: {
          items: facetResponse?.data?.map((element, index) => {
            const productData = getProductItemObject(element);
            return {
              ...productData,
              index,
              product_url: productData.product_url ? productData.product_url : facetResponse?.metaData?.canonicalTag,
              ...getProductListingAttributes(element, 'Pharmacy'),
            };
          }),
        },
      };
      
      const categoryListings = { listing_items: listingData?.ecommerce?.items };
      dataLayerSendEvent('ecommerce_list_update', categoryListings);
    }
    const searchFor = [];
    if (facetResponse?.filterText && facetResponse?.filterText !== '') {
      searchFor.push(facetResponse?.filterText);
    }
    if (facetResponse?.searchText && facetResponse?.searchText !== '') {
      searchFor.push(facetResponse?.searchText);
    }
    if (title) {
      searchFor.push(title);
    }
    if (selectedFacets?.length > 0) {
      selectedFacets.forEach((facet) => {
        if (facet?.key !== 'deliverBy' && facet?.values?.length > 0) {
          facet?.values?.forEach((fItem) => {
            searchFor?.push(fItem?.displayName);
          });
        }
      });
    }
    setSearchFor([...searchFor]);
    const sortFilterList = facetResponse?.facetList?.find((item) => item?.key === 'sort');
    setSortFilterOptions(sortFilterList?.facetBuckets);
    setSearchData({ ...searchData, totalEntry: facetResponse?.totalItems || 0 });
  }, [facetResponse?.data, facetResponse?.filterText, facetResponse?.searchText, selectedFacets?.length, title]);

  React.useEffect(() => {
    if(router?.query?.text && facetResponse?.data?.length > 0) {
      const ecommerceData = {
        items: facetResponse?.data?.map((element, index) => {
          return { ...getProductItemObject(element), index: index + 1 };
        }),
      };
      dataLayerSendEvent('view_item_list', {
        screen_name: SCREEN_NAME.PHARMA_SEARCH_RESULTS,
        page_type: PAGE_NAME.SRP,
        search_term: router?.query?.text,
        referrer_page: props?.referrerPage,
        myaster_category: MY_ASTER_CATEGORY.AE,
        ecommerce: ecommerceData,
      });
    }
  }, [JSON.stringify(facetResponse?.data)]);

  React.useEffect(() => {
    setFacetResponse(props?.facetResponse);
    const searchFor = [];
    if (props?.facetResponse?.filterText && props?.facetResponse?.filterText !== '') {
      searchFor.push(props?.facetResponse?.filterText);
    }
    if (props?.facetResponse?.searchText && props?.facetResponse?.searchText !== '') {
      searchFor.push(props?.facetResponse?.searchText);
      resetAllFilters();
    }
    const filters = router?.query?.q?.split(':');
    if (filters?.length > 0) {
      const keyValuePairs = {};

      for (let i = 0; i < filters.length; i += 2) {
        const key = filters[i];
        const value = filters[i + 1];
        let trimmedValue = value
          ?.split(',')
          ?.map((item) => {
            if ((item) => item.includes('$')) {
              return item?.split('$')[0];
            }
          })
          .join(',');

        if (key !== 'sort' && key !== FACET_KEYS.EXPRESS && key !== FACET_KEYS.IS_FLASH) {
          keyValuePairs[key] = trimmedValue;
        }
        if (key === 'sort') {
          const displayValue = sortFilter?.find((sortType) => sortType?.key === trimmedValue);
          setSortBy({ key: trimmedValue, displayName: displayValue?.displayName });
        }
        if (key === 'productForm') {
          keyValuePairs[key] = trimmedValue;
        }
        if (key === FACET_KEYS.EXPRESS) {
          setIsExpress(JSON.parse(trimmedValue));
        }
        if (key === FACET_KEYS.IS_FLASH) {
          setIsFlash(JSON.parse(trimmedValue));
        }
        if (key === 'price') {
          const minSelectedPrice = trimmedValue?.split(',')?.[0];
          const maxSelectedPrice = trimmedValue?.split(',')?.[1];
          setSelectedPrices({ minVal: minSelectedPrice, maxVal: maxSelectedPrice });
        }
      }

      const selectedUrlFacets = Object.keys(keyValuePairs).map((item) => {
        let multipleValues = [];
        if (keyValuePairs[item]?.includes(',')) {
          multipleValues = keyValuePairs[item]?.split(',');
        } else {
          multipleValues.push(keyValuePairs[item]);
        }
        return {
          key: item,
          values: multipleValues?.map((item) => ({
            displayName: item,
            key: item,
          })),
        };
      });

      setSelectedFacets([...selectedFacets, ...selectedUrlFacets]);
    }

    if (router?.query?.catPath) {
      const categoryFacet = props?.facetResponse?.facetList?.find((item) => item?.key === 'categoryPath');
      if (categoryFacet?.facetBuckets?.length > 0) {
        const findSelectedItem = categoryFacet?.facetBuckets?.find((fItem) => fItem?.key === router?.query?.catPath);
        if (findSelectedItem) {
          setSelectedFacets([{ key: 'categoryPath', values: [findSelectedItem] }]);
        }
      }
    }
    if (searchFor?.length > 0) {
      setSearchFor([...searchFor]);
    }
  }, [
    props?.facetResponse?.data,
    props?.facetResponse?.filterText,
    props?.facetResponse?.searchText,
    router?.query?.catPath,
    router?.query?.q
  ]);

  React.useEffect(() => {
    setPriceFacet(props?.priceFacet);
  }, [props?.priceFacet]);

  React.useEffect(() => {
    setCurrentPage(router?.query?.page ?? 1);
  }, [router?.query?.page]);

  React.useEffect(() => {
    if(!router?.query?.q){
      resetAllFilters();
    }
  }, [router?.query?.brands?.[0], router?.query?.categories?.[0], router?.query?.q]);


  React.useEffect(() => {
    if (selectedFacets?.length > 0) {
      const searchForNew = [];
      if (isFilterApplied && router?.query?.page > 1) {
        router.push({ query: { ...router.query, page: 1 } }, undefined, { shallow: true });
      }
      selectedFacets.forEach((facet) => {
        if (facet?.key !== 'deliverBy' && facet?.values?.length > 0) {
          facet?.values?.forEach((fItem) => {
            searchForNew?.push(fItem?.displayName);
          });
        }
      });
      if (searchForNew?.length > 0) {
        setSearchFor([...searchedFor, ...searchForNew]);
      }
    }
  }, [selectedFacets]);

  // on any Filter Change api call
  React.useEffect(() => {
    if (userLocationZone?.length > 0) {
      props?.setIsFirstCalled(false);
    }
    if (!props?.isFirstCalled || router?.query?.q) {
      onFilterChanged();
    }
  }, [
    selectedFacetsDependent,
    SortByDependent,
    selectedPriceDependent,
    isExpressDependent,
    isFlashDependent,
    pageDependent,
    userLocationZone,
    router?.query?.q
  ]);

  React.useEffect(() => {
    let pageType = props?.pageType;
    if (category && category !== '') {
      pageType = 'Products By Category';
    } else if (brand && brand !== '') {
      pageType = 'Products By Brand';
    } else if (q && q !== '') {
      pageType = 'Products By search';
    }

    setGAPageType(pageType);
    if (facetResponse?.oosData && router?.query?.q && router?.query?.q !== '') {
      const eventParams = {
        screenName: 'Search Result',
        pageType: 'Epharmacy Search Result Page',
        referrerPage: props?.referrerPage,
      };
      analayticsParams.current = eventParams;
      dataLayerSendEpharmacyPageViewEvent(eventParams);
      dataLayerSendEvent('search_page', {});
    } else if (router?.query?.q && router?.query?.q !== '') {
      const eventParams = {
        screenName: 'Search Result',
        pageType: 'Epharmacy Search Result Page',
        referrerPage: props?.referrerPage,
      };
      analayticsParams.current = eventParams;
      dataLayerSendEpharmacyPageViewEvent(eventParams);
      dataLayerSendEvent('search_page', {});
    }  
  }, []);

  useEffect(() => {
    const params = {
      pageType: 'product listing page',
      referrerPage: props?.referrerPage,
    };
    if (router?.query?.categories?.length === 2) {
      params.pageId = router?.query?.categories[1];
      params.screenName = `${router?.query?.categories[0]} category`;
    } else if (router?.query?.categories?.length === 1) {
      params.pageId = router?.query?.categories[0];
      params.screenName = null;
    } else if (router?.query?.brands?.length === 2) {
      params.pageId = router?.query?.brands[1];
      params.screenName = `${router?.query?.brands[0]} brand`;
    } else if (router?.query?.brands?.length === 1) {
      params.pageId = router?.query?.brands[0];
      params.screenName = null;
    } else if (router?.query?.text && router?.query?.text !== '') {
      params.screenName = 'pharma search result';
      params.pageType = 'search result page';
    }

    analayticsParams.current = params;
    dataLayerSendEpharmacyPageViewEvent(params);
    setPageName(params.screenName || 'Product Listing Page');
  }, [router?.query?.brands?.[0], router?.query?.categories?.[0], router?.query?.text]);

  useEffect(() => {
    const handleScroll = debounce(() => {
      const currentScrollY = window.scrollY;

      if (currentScrollY > lastScrollY.current) {
        setIsIncreasing(true);
      } else if (currentScrollY + 18 < lastScrollY.current) {
        setIsIncreasing(false);
      }

      lastScrollY.current = currentScrollY;
    }, 50);

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  React.useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'auto';
    }
  }, [isOpen]);

  React.useEffect(() => {
    if (!showUpSellingCarousel) {
      setFirstSetData(facetResponse?.data);
      setSecondSetData([]);
    }
  }, [showUpSellingCarousel, facetResponse?.data]);

  React.useEffect(() => {
    setShowUpSellingCarousel(false);
  }, [userLocationZone])

 const sendFilterClickEvent = () => { 
    dataLayerSendEvent('filter_click', {
     screen_name: analayticsParams.current?.screenName,
     page_type: analayticsParams.current?.pageType,
     page_id: analayticsParams.current?.pageId || '',
     filter_category: recentSelectedFacet?.displayName?.toLowerCase(),
     selection: recentSelectedFacet?.selectedFacet?.selected ? 'filter enabled' : 'filter disabled',
     filter_value: recentSelectedFacet?.selectedFacet?.displayName || recentSelectedFacet?.values[0]?.displayName || '',
     myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
   });
 };

 const sendSortByEvent = (sortByParam) => {
  dataLayerSendEvent('sort_by', {
    screen_name: analayticsParams.current?.screenName,
    page_type: analayticsParams.current?.pageType, 
    myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
    page_id: analayticsParams.current?.pageId,
    option: sortByParam?.toLowerCase()
  });
};

const sendPaginationClickEvent = (pageNumber, direction) => {
  dataLayerSendEvent('pagination_products', {
    screen_name: analayticsParams.current?.screenName,
    page_type: analayticsParams.current?.pageType, 
    myaster_category: ONE_ASTER_CATEGORY.PHARMACY,
    page_id: analayticsParams.current?.pageId,
    selection: direction || pageNumber
   });
};

 useEffect(() => {
   if (recentSelectedFacet) {
     sendFilterClickEvent();
   }
 }, [recentSelectedFacet]);

 let breadcrumChild = '';
 
 if(router?.pathname?.includes(ONLINE_PHARMACY_CATEGORY_ROUTE) && props?.facetResponse?.categoryPathDetail){
  breadcrumChild = web_feature_flaging?.isBreadcrumbAEDisabled ? [
    { text: t('Breadcrumb.home'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
    { text: t('Home.categoryPathDetails'), url: generateURL(props?.facetResponse?.categoryPathDetail)}
  ] :
  [
    { text: t('Breadcrumb.home'), link: generateURL(HOME) },
    { text: t('Home.onlinePharmacy'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
    { text: t('Home.categoryPathDetails'), url: generateURL(props?.facetResponse?.categoryPathDetail)}
  ]
 } else if (router?.pathname?.includes(ONLINE_PHARMACY_BRAND_ROUTE)){
  breadcrumChild = web_feature_flaging?.isBreadcrumbAEDisabled ? [
    { text: t('Breadcrumb.home'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
    { text: t('Home.brands'),  link: generateURL(BRAND_LISTING_ROUTE) }
  ] : [
    { text: 'Home', link: generateURL(HOME) },
    { text: t('Home.onlinePharmacy'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
    { text: t('Home.brands'),  link: generateURL(BRAND_LISTING_ROUTE) }
  ]
 } else {
  breadcrumChild = web_feature_flaging?.isBreadcrumbAEDisabled ? [
    { text: t('Breadcrumb.home'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
  ] : [
    { text: t('Breadcrumb.home'), link: generateURL(HOME) },
    { text: t('Home.onlinePharmacy'), link: generateURL(ONLINE_PHARMACY_ROUTE) },
  ]
 }

  return (
    <>
      <Loader isLoading={loadingList} />
      <Container className="product-detail-container">
        {web_feature_flaging?.isKsaUser &&
          <Row className="mt-4">
            <DownloadAppBanner screenName={analayticsParams?.current?.screenName} pageType={analayticsParams?.current?.pageType} />
          </Row>
        }
        <Row className="pt-3 pb-2 breadcrumbsRow">
          {(listData?.length > 0 ||
            isExpress ||
            category ||
            name ||
            brand ||
            offerType ||
            (router?.query?.q && listData?.length > 0)) && (
            <BreadcrumbControl
              main={getBreadcrumbCurrentText()}
              childs={breadcrumChild}
              appVariant="epharmacy plpPage"
            />
          )}
        </Row>
        <Row className="my-md-3 mainContentPLP">
          {listData?.length > 0 ||
          isExpress ||
          category ||
          name ||
          brand ||
          isPriceFilterSelected() ||
          isFilterApplied ? (
            <Col sm={4} md={3} className="productFilterRow">
              <ProductFilter
                setShowUpSellingCarousel={setShowUpSellingCarousel}
                facetList={facetList}
                facetResponseCategoryPath={props?.facetResponse?.categoryPath ?? false}
                selectedFacets={selectedFacets}
                setSelectedFacets={setSelectedFacets}
                title={t('EpharmacyFilter.Filter')}
                rightTitle={t('EpharmacyFilter.clearFilter')}
                handleIsExpress={handleIsExpress}
                handleIsFlash={handleIsFlash}
                setIsExpress={setIsExpress}
                setIsFlash={setIsFlash}
                isExpress={isExpress}
                isFlash={isFlash}
                price={priceFacet}
                resetAllFilters={resetAllFilters}
                selectedPrices={selectedPrices}
                handlePriceOnChange={({ minVal, maxVal }) => {
                  setIsFilterApplied(true);
                  setShowUpSellingCarousel(false);
                  router.push({ query: { ...router.query, page: 1 } }, undefined, { shallow: true });
                  setSelectedPrices({ minVal, maxVal });
                  setRecentSelectedFacet({
                    displayName: 'price',
                    selectedFacet: { displayName: `${minVal} AED to ${maxVal} AED`, selected: true },
                  });
                }}
                setIsOpen={() => setIsOpen(false)}
                isOpen={isOpen}
                setRecentSelectedFacet={setRecentSelectedFacet}
              />
            </Col>
          ) : (
            ''
          )}

          <Col sm={8} md={9} className="ps-0 mx-auto">
          <div>
            <BannerSliderWithImage
              data={pageBanners}
              sectionName={'plp banner'}
              appVariant={"plp-banner"}
              pageType={analayticsParams?.current?.pageType} 
              referrerPage={props?.referrerPage}
              pageName={analayticsParams?.current?.screenName}
              brandId={router?.query?.brand || props?.queryParamBrands}
              catId={props?.queryParamCategory}
            />
            </div>
            <div className={!loadingList && checkFilterApplied ? `stickySortBy ${!facetResponse?.oosData && scrollY > 140 && !isIncreasing? 'sticky' : 'stickyTop80'}` : ''}>
              <SearchTitleBar
                setIsOpen={() => setIsOpen(true)}
                sortFilterOptions={sortFilterOptions}
                onSortBy={(value) => {
                  setIsFilterApplied(true);
                  setShowUpSellingCarousel(false);
                  setSortBy(sortFilterOptions?.find((item) => item?.displayName === value));
                  sendSortByEvent(value);
                }}
                sortBy={sortBy}
                facetResponse={facetResponse}
                loadingList={loadingList}
                checkFilterApplied={checkFilterApplied}
                searchedFor={searchedFor}
              />
            </div>
            {isScheduledProducts?.length > 0 && facetResponse?.scheduledDeliveryMessage && showSheduledDeliveryMessage && (
              <div className="disclaimer-scheduled-wrapper">
                <div className="diclaimer-img">
                  <Image src={IC_SCHEDULE_MOON_ICON} alt="schedule moon icon img" width={15} height={22} />
                </div>
                <div
                  className="disclaimer-scheduled-text"
                  dangerouslySetInnerHTML={{ __html: facetResponse?.scheduledDeliveryMessage }}
                ></div>
              </div>
            )}
            <BlankCard
              noTitleBar
              customClass={`${
                checkFilterApplied
                  ? 'product-outer-wrapper search-title-wrapper'
                  : 'no-search-result-found-container product-outer-wrapper search-title-wrapper'
              } ${searchedFor?.length > 0 ? '' : 'remove-light-text-spacing'}`}
            >
              {!loadingList && listData?.length <= 0 && <NoResultFound />}
              {facetResponse?.oosData?.length > 0 && (
              <div style={{ 
                padding: '16px',
                gap: '16px',
                background: '#F2F8FD',

              }}>
              <SlickSlider 
                sliderSettings={{
                  responsive,
                  slidesToShow: 4,
                  infinite: false,
                  className: '',
                  dots: false,
                }}
              >
                {facetResponse?.oosData?.length > 0 &&
                  facetResponse?.oosData?.map((item, index) => {
                    const smallImage = item.small_image;
                    return (
                      <div
                        key={item?.productId}
                        style={{
                          width: '195px',  
                          height: '322px',   
                          gap: '16px',
                          margin: '0 8px',  
                        }}
                      >
                      <ProductItem
                        key={item?.productId}
                        index={index}
                        categoryImage={smallImage || getAttributeItemFromArray(item?.customAttribute, 'small_image')}
                        name={item?.name}
                        newPrice={item?.specialPrice || item?.special_price}
                        actualPrice={item?.price}
                        express={item?.express || item?.express_bool}
                        isFlash={item?.isFlash}
                        deliverBy={item?.deliverBy}
                        deliveryText={item?.deliveryText}
                        currency={item?.currency}
                        freeDelivery={item?.freeDelivery}
                        outOfStock={!item?.inStock}
                        sku={item?.sku}
                        isOptics={item?.isOpticalProduct}
                        availableStock={item?.quantity}
                        product={item}
                        orderWithin={item?.orderWithin}
                        isLoader={false}
                        pageName={analayticsParams?.current?.screenName}
                        itemListId={item?.offerType}
                        screen={analayticsParams?.current?.screenName}
                        pageType={analayticsParams?.current?.pageType}
                        facetResponse={facetResponse}
                        isBundle={item?.isBundled}
                        BundleDetails={item?.tierPrices}
                        BundleImage={item?.small_image}
                        referrerPage={props?.referrerPage} 
                        hasRX={item?.itemLabels?.includes(AE_GLOBAL?.RX)}
                        lang={props?.lang}
                        />
                      </div>
                    );
                  })}
              </SlickSlider>
            </div>
            )}
              {facetResponse?.data && facetResponse?.oosData && facetResponse.data.length > 0 ? (
                  <>
                  <div className={!loadingList && checkFilterApplied ? `searchStickySortBy ${scrollY > 180 ? 'sticky' : ''}` : ''}>
                  <div className="suggested-products">{t('EpharmacySearch.suggestedProducts')}</div>
                  <SearchSortBy
                    setIsOpen={() => setIsOpen(true)}
                    sortFilterOptions={sortFilterOptions}
                    onSortBy={(value) => {
                      setIsFilterApplied(true);
                      setShowUpSellingCarousel(false);
                      setSortBy(sortFilterOptions?.find((item) => item?.displayName === value));
                    } }
                    sortBy={sortBy}
                    facetResponse={facetResponse}
                    loadingList={loadingList}
                    checkFilterApplied={checkFilterApplied} />
                </div>
                <div className="product-card-section">
                    {facetResponse?.data.map((item, index) => (
                      <ProductItem
                        classname="product-card-wrapper"
                        getProductIndex={getProductIndexAddedToCart}
                        key={item?.sku}
                        index={index}
                        avgRating={item?.avgRating}
                        badgeDetails={item?.badgeDetails}
                        offerBadge={item?.badgeDetails?.offerBadge}
                        asterBadge={item?.badgeDetails?.asterBadge?.[0]}
                        categoryImage={item?.small_image ? item?.small_image : ''}
                        name={item?.name}
                        newPrice={item?.special_price > 0 ? item?.special_price : ''}
                        actualPrice={item?.price}
                        express={item?.express_bool}
                        isFlash={item?.isFlash}
                        isOptics={item?.isOpticalProduct}
                        deliverBy={item?.inStock && item?.deliverBy ? item?.deliverBy : ''}
                        deliveryText={item?.inStock && item?.deliveryText ? item?.deliveryText : ''}
                        currency={item?.currency ?? currency}
                        outOfStock={!item?.inStock}
                        sku={item?.sku}
                        lowestPriceLabel={item?.lowestPriceLabel}
                        availableStock={item?.quantity}
                        product={item}
                        isBundle={item?.isBundled}
                        isScheduled={item?.isScheduled}
                        BundleDetails={item?.tierPrices}
                        BundleImage={item?.small_image}
                        sourceContainerTitle={t('EPharmacyHome.searchResult')}
                        isInProductListingPage
                        pageName={analayticsParams?.current?.screenName}
                        sectionName="Product Listing page"
                        itemListName={(() => {
                          if (facetResponse?.filterText) {
                            return facetResponse?.filterText;
                          }
                          if (facetResponse?.searchText) {
                            return facetResponse?.searchText;
                          }
                          return 'Product Listing Page';
                        })()}
                        itemListId={category || brand || props?.queryParamBrands || props?.queryParamCategory || ''}
                        screen={screenNameForEvent}
                        pageType={analayticsParams?.current?.pageType} 
                        referrerPage={props?.referrerPage}
                        hasRX={item?.itemLabels?.includes(AE_GLOBAL?.RX)}
                        lang={props?.lang}
                        />
                    ))}
                  </div>
                  </>
              ) : (
                <div className="product-card-section">
                  {firstSetData?.map((item, index) => (
                    <ProductItem
                      classname="product-card-wrapper"
                      getProductIndex={getProductIndexAddedToCart}
                      key={item?.sku}
                      index={index}
                      avgRating={item?.avgRating}
                      badgeDetails={item?.badgeDetails}
                      offerBadge={item?.badgeDetails?.offerBadge}
                      asterBadge={item?.badgeDetails?.asterBadge?.[0]}
                      categoryImage={item?.small_image ? item?.small_image : ''}
                      name={item?.name}
                      isOptics={item?.isOpticalProduct}
                      newPrice={item?.special_price > 0 ? item?.special_price : ''}
                      actualPrice={item?.price}
                      express={item?.express_bool}
                      isFlash={item?.isFlash}
                      deliverBy={item?.inStock && item?.deliverBy ? item?.deliverBy : ''}
                      deliveryText={item?.inStock && item?.deliveryText ? item?.deliveryText : ''}
                      currency={item?.currency ?? currency}
                      outOfStock={!item?.inStock}
                      lowestPriceLabel={item?.lowestPriceLabel}
                      sku={item?.sku}
                      isBundle={item?.isBundled}
                      isScheduled={item?.isScheduled}
                      BundleDetails={item?.tierPrices}
                      BundleImage={item?.small_image}
                      availableStock={item?.quantity}
                      product={item}
                      sourceContainerTitle={t('EPharmacyHome.searchResult')}
                      isInProductListingPage
                      pageName={analayticsParams?.current?.screenName}
                      sectionName="Product Listing page"
                      itemListName={pageName}
                      itemListId={category || brand || props?.queryParamBrands || props?.queryParamCategory || ''}
                      screen={screenNameForEvent}
                      pageType={analayticsParams?.current?.pageType} 
                      referrerPage={props?.referrerPage}
                      hasRX={item?.itemLabels?.includes(AE_GLOBAL?.RX)}
                      lang={props?.lang}
                      />
                  ))}
                </div>
              )}

              {showUpSellingCarousel && <UpSellingCarousel addToCartSkuIds={addToCartSkuIds} />}
              <div className="product-card-section">
                {secondSetData?.map((item, index) => (
                  <ProductItem
                    classname="product-card-wrapper"
                    getProductIndex={getProductIndexAddedToCart}
                    key={item?.sku}
                    index={Number(index) + firstSetData.length}
                    avgRating={item?.avgRating}
                    badgeDetails={item?.badgeDetails}
                    offerBadge={item?.badgeDetails?.offerBadge}
                    asterBadge={item?.badgeDetails?.asterBadge?.[0]}
                    categoryImage={item?.small_image ? item?.small_image : ''}
                    name={item?.name}
                    newPrice={item?.special_price > 0 ? item?.special_price : ''}
                    actualPrice={item?.price}
                    express={item?.express_bool}
                    isFlash={item?.isFlash}
                    isOptics={item?.isOpticalProduct}
                    deliverBy={item?.inStock && item?.deliverBy ? item?.deliverBy : ''}
                    deliveryText={item?.inStock && item?.deliveryText ? item?.deliveryText : ''}
                    currency={item?.currency ?? currency}
                    isBundle={item?.isBundled}
                    isScheduled={item?.isScheduled}
                    BundleDetails={item?.tierPrices}
                    BundleImage={item?.small_image}
                    outOfStock={!item?.inStock}
                    lowestPriceLabel={item?.lowestPriceLabel}
                    sku={item?.sku}
                    availableStock={item?.quantity}
                    product={item}
                    sourceContainerTitle={t('EPharmacyHome.searchResult')}
                    isInProductListingPage
                    pageName={analayticsParams?.current?.screenName}
                    sectionName="Product Listing page"
                    itemListName={pageName}
                    itemListId={category || brand || props?.queryParamBrands || props?.queryParamCategory || ''}
                    screen={analayticsParams?.current?.screenName} 
                    pageType={analayticsParams?.current?.pageType} 
                    referrerPage={props?.referrerPage}
                    hasRX={item?.itemLabels?.includes(AE_GLOBAL?.RX)}
                    lang={props?.lang}
                    />
                ))}
              </div>
              {listData?.length > 0 && (
                <Pagination
                  className="pagination-bar"
                  currentPage={Number(currentPage)}
                  totalCount={facetResponse?.totalItems}
                  pageSize={facetResponse?.pageSize}
                  onPageChange={(page, direction) => {
                    sendPaginationClickEvent(page,direction);
                    router.push(
                      {
                        query: {
                          ...router.query,
                          page,
                        },
                      },
                      undefined,
                      {
                        shallow: true,
                      },
                    );
                  }}
                  appVariant="epharmacy"
                />
              )}
            </BlankCard>
            <PlpBottomCart />
          </Col>
        </Row>
      </Container>
      {!loadingList && listData?.length <= 0 && (
        <NoResultFoundReCarousel  facetResponse={facetResponse}/>
      )}
    </>
  );
};

SearchResultPageInner.defaultProps = {
  pageType: '',
  queryParam: {},
  facetResponse: {},
  selectedFacet: [],
  priceFacet: {},
  queryParamBrands: '',
  queryParamCategory: '',
  getParams: () => {},
  setIsFirstCalled: () => {},
  isFirstCalled: false,
  referrerPage: '',
};

SearchResultPageInner.propTypes = {
  pageType: PropTypes.string,
  queryParam: PropTypes.object,
  facetResponse: PropTypes.object,
  queryParamBrands: PropTypes.string,
  queryParamCategory: PropTypes.string,
  getParams: PropTypes.func,
  setIsFirstCalled: PropTypes.func,
  isFirstCalled: PropTypes.bool,
  priceFacet: PropTypes.object,
  selectedFacet: PropTypes.array,
  referrerPage: PropTypes.string,
};

export default SearchResultPageInner;
